(function ErezRemoveFromDirectMailForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'RemoveFromDirectMail',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// init qtip for the breakdown
		Adzuki.QTip.attachQtip(undefined, undefined, undefined, 'left');
	};

	form.success = function success(response)
	{
		if (response.data.client_id) {
			Adzuki.MoveBetweenLists.removeCompletely(response.data.client_id);
			Adzuki.Sidebar.toggleRightSidebar('off');
			Adzuki.StatusMessage('Success', 'Client has been removed from Direct Mail.');
		}
	};
}(jQuery, window.Adzuki || {}));
